import "core-js/modules/es6.string.fixed";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
export default {
  name: "Trend",
  props: {
    // 同title
    term: {
      type: String,
      default: '',
      required: true
    },
    // 百分比
    percentage: {
      type: Number,
      default: null
    },
    type: {
      type: Boolean,
      default: null
    },
    target: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    },
    fixed: {
      type: Number,
      default: 2
    }
  },
  data: function data() {
    return {
      trend: this.type && 'up' || 'down',
      rate: this.percentage
    };
  },
  created: function created() {
    var type = this.type === null ? this.value >= this.target : this.type;
    this.trend = type ? 'up' : 'down';
    this.rate = (this.percentage === null ? Math.abs(this.value - this.target) * 100 / this.target : this.percentage).toFixed(this.fixed);
  }
};